const COMPILED_CONSTANTS = {
    "SubDomain": "vbc.qar",
    "qarCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/E3J1R9U7DOECU8",
    "qarCloudFrontDistributionId": "E3J1R9U7DOECU8",
    "qarApiCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/E37KLXQ0LHUV0M",
    "qarApiProxyUrl": "https://qar-proxy.vbsp.dev.nasco.com",
    "qarNascoDomain": "vbsp.dev.nasco.com",
    "qarOriginAccessControlId": "ELU2VNVZ5IDQW",
    "qarFrontendBucketDomainName": "qar-frontend-730335180919-us-east-1.s3.amazonaws.com",
    "qarFrontendBucketName": "qar-frontend-730335180919-us-east-1",
    "qarApiGatewayId": "ac77pd2sdd",
    "AppConfigConfigurationProfileFeatureFlagsId": "2l7m5km",
    "AppConfigEnvironmentId": "cla2jn4",
    "AppConfigApplicationId": "wvio9q1",
    "nexusPublicApiGatewayId": "c0rib5vr69",
    "nexusApiGatewayId": "q30ovyib5g",
    "nascoNexusLambdaExecutionRoleArn": "arn:aws:iam::730335180919:role/nasco-nexus-lambda-execution-role",
    "NexusLambdaSecurityGroupId": "sg-02803d522cea186b2",
    "nexustoprocessBucketName": "nexus-to-process-730335180919-us-east-1",
    "nexusfailedprocessingBucketName": "nexus-failed-processing-730335180919-us-east-1",
    "nexusAwsAccountId": "730335180919",
    "nexusprocessedBucketName": "nexus-processed-730335180919-us-east-1",
    "referencedevBucketName": "reference-dev-730335180919-us-east-1",
    "nexusdynamoBucketName": "nexus-dynamo-730335180919-us-east-1",
    "nexusquarantineBucketName": "nexus-quarantine-730335180919-us-east-1",
    "nexusNascoNexusRedshiftRole": "arn:aws:iam::730335180919:role/nasco-nexus-redshift-role-nexus",
    "nexusRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:730335180919:workgroup/f9bd8eb6-f433-464f-9a9e-6f34229a6ed7",
    "nexusUserPoolId": "us-east-1_N3Ls9TkB3",
    "nexusSecurityGroupId": "sg-0de2d41a37eafe01c",
    "nexusCognitoDomain": "nexus-vbc-730335180919-us-east-1",
    "nexusUserPoolClientId": "5uao6c2ch9eabn9fqksglmfh4k",
    "evolveAppInferenceProfileArn": "arn:aws:bedrock:us-east-1:730335180919:application-inference-profile/jaraxuobif7c",
    "evolveAppInferenceProfile46Arn": "arn:aws:bedrock:us-east-1:730335180919:application-inference-profile/823awbmgtluk",
    "nexusProjectPrefix": "nexus",
    "nexusNascoDomain": "vbsp.dev.nasco.com",
    "nexusApiProxyUrl": "https://nexus-proxy.vbsp.dev.nasco.com",
    "nexusnexusApiDomainNameDomainNameArn": "arn:aws:apigateway:us-east-1:730335180919:/domainnames/nexus.vbsp.dev.nasco.com+7xu1u5j2el",
    "nexusApiCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/E3NTSJ1LXQ5886",
    "nexusNewSubDomain": "vbc.nexus.fe",
    "nexusFrontendBucket": "nexus-frontend-730335180919-us-east-1",
    "nexusCloudFrontDistributionId": "ER4N1BC4G0JOB",
    "nexusCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/ER4N1BC4G0JOB",
    "evolveNascoNexusRedshiftRole": "arn:aws:iam::730335180919:role/nasco-evolve-redshift-role-nexus",
    "evolveRedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:730335180919:workgroup/8de3b5c3-c053-4910-8277-ebca2d9c78c0",
    "RedshiftWorkgroupArn": "arn:aws:redshift-serverless:us-east-1:730335180919:workgroup/8de3b5c3-c053-4910-8277-ebca2d9c78c0",
    "evolveRedshiftSnapshotLambdaRoleArn": "arn:aws:iam::730335180919:role/nasco-evolve-redshift-snapshot-lambda-role",
    "evolveContractIngestionApiGatewayId": "46he7otz9f",
    "evolveSettlementApiGatewayId": "akopmhu5m0",
    "evolveNexusPublicApiGatewayId": "x954wbjjkc",
    "evolveNexusApiGatewayId": "03dkcbvek8",
    "evolveOSApiGatewayId": "490lpn8g8h",
    "evolvenexusToProcessBucketName": "evolve-nexus-to-process-730335180919-us-east-1",
    "evolvemediaBucketName": "evolve-media-730335180919-us-east-1",
    "evolvesynthDataBucketName": "evolve-synth-data-730335180919-us-east-1",
    "evolveAwsAccountId": "730335180919",
    "evolvenexusFailedProcessingBucketName": "evolve-nexus-failed-processing-730335180919-us-east-1",
    "evolvemigrationBucketName": "evolve-migration-730335180919-us-east-1",
    "evolvereportsBucketName": "evolve-reports-730335180919-us-east-1",
    "evolvedevBucketName": "evolve-dev-730335180919-us-east-1",
    "evolvesettlementArtifactsBucketName": "evolve-settlement-artifacts-730335180919-us-east-1",
    "evolvenexusProcessedBucketName": "evolve-nexus-processed-730335180919-us-east-1",
    "evolvequarantineBucketName": "evolve-quarantine-730335180919-us-east-1",
    "evolvetemporaryBucketName": "evolve-temporary-730335180919-us-east-1",
    "evolveflowArtifactsBucketName": "evolve-flow-artifacts-730335180919-us-east-1",
    "evolvedynamoBucketName": "evolve-dynamo-730335180919-us-east-1",
    "evolvecontractUploadsBucketName": "evolve-contract-uploads-730335180919-us-east-1",
    "evolveexportDynamoBucketName": "evolve-export-dynamo-730335180919-us-east-1",
    "evolvememoriesBucketName": "evolve-memories-730335180919-us-east-1",
    "securityGroupId": "sg-0b71bd83de1d6edc4",
    "evolveUserPoolId": "us-east-1_56weOGh7d",
    "evolveGuardDutyMalwareAlertTopicArn": "arn:aws:sns:us-east-1:730335180919:guardduty-malware-alerts",
    "evolveUserPoolClientId": "2c4ce5mqgl5lvodm5kcmudbss9",
    "evolveCognitoDomain": "vbc-730335180919-us-east-1",
    "evolveSecurityGroupId": "sg-0b71bd83de1d6edc4",
    "evolveNexusCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/E1XBEXFYY91VBV",
    "evolveNexusCloudFrontDistributionId": "E1XBEXFYY91VBV",
    "evolveNexusFrontendBucket": "evolve-nexus-frontend-730335180919-us-east-1",
    "evolveNexusSubDomain": "vbc.nexus",
    "evolveOSFrontendBucketName": "evolve-os-frontend-730335180919-us-east-1",
    "evolveOSCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/EBM9BTXPWQDPI",
    "evolveOSSubDomain": "vbc.os",
    "evolveOSCloudFrontDistributionId": "EBM9BTXPWQDPI",
    "evolveNascoDomain": "vbsp.dev.nasco.com",
    "evolveApiProxyUrl": "https://vbc-proxy.vbsp.dev.nasco.com",
    "evolveApiCloudFrontDistributionArn": "arn:aws:cloudfront::730335180919:distribution/E1OKEV6D9PLNDC",
    "signingProfileVersionArn": "arn:aws:signer:us-east-1:730335180919:/signing-profiles/signingProfile_rlbJEtPYJqad/KNH5VQ7I1b",
    "custodianRoleName": "nasco-c7n",
    "errorTopicArn": "arn:aws:sns:us-east-1:730335180919:c7n-errors",
    "signingProfileName": "signingProfile_rlbJEtPYJqad",
    "scheduleGroupName": "CloudCustodian",
    "policySGId": "sg-0942135afbc3a15cc",
    "custodianRoleArn": "arn:aws:iam::730335180919:role/nasco-admin/nasco-c7n",
    "scheduleRoleArn": "arn:aws:iam::730335180919:role/nasco-admin/nasco-c7n-schedule",
    "custodianAdminRoleArn": "arn:aws:iam::730335180919:role/nasco-admin/nasco-c7n-admin",
    "tenableOneRoleArn": "arn:aws:iam::730335180919:role/nasco-admin/nasco-tenable-one",
    "bedrockLogging": "Yes",
    "logicMonitorRoleArn": "arn:aws:iam::730335180919:role/nasco-admin/nasco-logicmonitor",
    "snsKMSKeyAliasName": "alias/nasco/sns",
    "BaselineCloudFrontACLARN": "arn:aws:wafv2:us-east-1:730335180919:global/webacl/NASCO-CloudFront-Baseline/e21606cc-3a51-45aa-9286-aa0755e5f17e",
    "cfLoggingBucketName": "cloudfront-logs-730335180919-us-east-1",
    "s3LoggingBucketName": "s3-access-logs-730335180919-us-east-1",
    "breakGlassRoleArn": "arn:aws:iam::730335180919:role/nasco-admin/nasco-break-glass",
    "permsBoundaryPolicyARN": "arn:aws:iam::730335180919:policy/nasco/builder-permissions-boundary",
    "deploymentBucketName": "deployment-730335180919-us-east-1",
    "opsPermsBoundaryPolicyARN": "arn:aws:iam::730335180919:policy/nasco/ops",
    "TerraformStateBucketName": "tfstate-730335180919-us-east-1",
    "oidcProviderArn": "arn:aws:iam::730335180919:oidc-provider/api.bitbucket.org/2.0/workspaces/nascodevelopment/pipelines-config/identity/oidc",
    "LocalSecurityTopicName": "aws-controltower-SecurityNotifications",
    "LocalSecurityTopic": "arn:aws:sns:us-east-1:730335180919:aws-controltower-SecurityNotifications",
    "BaselineConfigDeliveryChannel": "aws-controltower-BaselineConfigDeliveryChannel",
    "BaselineConfigRecorder": "aws-controltower-BaselineConfigRecorder",
    "BaselineConfigRole": "arn:aws:iam::730335180919:role/aws-controltower-ConfigRecorderRole",
    "env": "dev"
}
export { COMPILED_CONSTANTS }